__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@kne-components/markdown-components-render";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@kne/current-lib_markdown-components-render", "0.1.10", () => (Promise.all([__webpack_require__.e(755), __webpack_require__.e(691), __webpack_require__.e(922), __webpack_require__.e(830)]).then(() => (() => (__webpack_require__(71830))))));
			register("@kne/react-fetch", "1.5.5", () => (Promise.all([__webpack_require__.e(496), __webpack_require__.e(623), __webpack_require__.e(201), __webpack_require__.e(922)]).then(() => (() => (__webpack_require__(3201))))));
			register("@kne/react-fetch", "1.5.5", () => (Promise.all([__webpack_require__.e(755), __webpack_require__.e(351), __webpack_require__.e(922)]).then(() => (() => (__webpack_require__(64351))))));
			register("@kne/remote-loader", "1.3.3", () => (Promise.all([__webpack_require__.e(496), __webpack_require__.e(922), __webpack_require__.e(848)]).then(() => (() => (__webpack_require__(31467))))));
			register("antd", "5.29.3", () => (Promise.all([__webpack_require__.e(736), __webpack_require__.e(922), __webpack_require__.e(714), __webpack_require__.e(469)]).then(() => (() => (__webpack_require__(74736))))));
			register("axios", "1.13.4", () => (Promise.all([__webpack_require__.e(84), __webpack_require__.e(379)]).then(() => (() => (__webpack_require__(62084))))));
			register("dayjs", "1.11.19", () => (__webpack_require__.e(446).then(() => (() => (__webpack_require__(60446))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(86), __webpack_require__.e(922)]).then(() => (() => (__webpack_require__(83848))))));
			register("react-router-dom", "6.30.3", () => (Promise.all([__webpack_require__.e(245), __webpack_require__.e(922), __webpack_require__.e(714)]).then(() => (() => (__webpack_require__(53245))))));
			register("react", "18.3.1", () => (__webpack_require__.e(233).then(() => (() => (__webpack_require__(98233))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};